import React, { useEffect, useState } from "react";
import {
  useDispositionQuery,
  useGetDispositionStatusQuery,
  useTicketDynamicFieldsQuery,
} from "../../Services/ticket/CreateTicket";
import { USER_TEAM_ID } from "../../constants";
import { CloseButton } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Loader } from "react-bootstrap-typeahead";
import ReactModal from "react-modal";
import WorkflowModal from "./WorkflowModal";
import { Box, IconButton, Modal, Typography } from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import EmailDispositionWorkflowModal from "./EmailDIspositionWorkflowModal";

interface IPROPS {
  closeModal: any;
  storedDisposition: any;
  refetch: any;
  refetchEmailTrail:any ;
  trigger: any;
  isLoading: any;
  ticketId: any;
  otherMailDetails: any;
  value: any;
}

interface FetchError {
  status: number;
  data: {
    disposition?: string[];
  };
}

const ReplyDispositionModal: React.FC<IPROPS> = ({
  closeModal,
  storedDisposition,
  refetch,
  refetchEmailTrail,
  trigger,
  isLoading,
  ticketId,
  otherMailDetails,
  value,
}) => {
  const getTeamId = localStorage.getItem(USER_TEAM_ID);
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const [lastSelectedId, setLastSelectedId] = useState<number | null>(null);
  const [selectedId, setSelectedId] = useState("");
  const [checkForValue, setCheckForValue] = useState(false);
  const [isEditDispositionTrue, setIsEditDispositionTrue] = useState(false);
  const [statusModalOpen, setStatusModalOpen] = useState(false);
  const [checkValue, setCheckValue] = useState<any>([]);
  const [ticketName, setTicketName] = useState<any>("");
  const [dynamicData, setDynamicData] = useState<[string, any][]>([]);
  const [workflowModalClicked, setWorkflowModalClicked] = useState(false);
  const [shouldFetch, setShouldFetch] = useState(false);

  const [skipDispositionQuery, setSkipDispositionQuery] =
    useState<boolean>(true);
  const [showAdditionalField, setShowAdditionalField] = useState(false);
  const [hasSubTopicsAvailable, setHasSubTopicsAvailable] = useState(false);

  const [dispoError, setDispoError] = useState<FetchError>(null);

  const { data: ticketDynamicFields } = useTicketDynamicFieldsQuery({});

  console.log(otherMailDetails?.action?.ticket, "otherMailDetails");

  const isFetchBaseQueryError = (
    error: unknown,
  ): error is FetchBaseQueryError => {
    return (error as FetchBaseQueryError)?.data !== undefined;
  };

  const closeStatusModal = () => {
    setStatusModalOpen(false);
    closeModal();
  };

  const { data: Disposition } = useDispositionQuery(getTeamId);

  const {
    data: fetchDispositionStatus,
    error: fetchDispositionError,
    status: fetchDispositionStats,
  } = useGetDispositionStatusQuery(lastSelectedId, {
    skip: !shouldFetch,
  });

  useEffect(() => {
    if (fetchDispositionError && isFetchBaseQueryError(fetchDispositionError)) {
      setDispoError(fetchDispositionError as FetchError);
    }
  }, [fetchDispositionError]);

  const [options, setOptions] = useState(Disposition || []);
  const { uuid } = useParams();

  useEffect(() => {
    if (Disposition && storedDisposition) {
      let initialSelectedIds: number[] = [];
      let currentOptions = Disposition;
      let finalLastId = null;

      storedDisposition.forEach((storedValue: string) => {
        const matchingOption = currentOptions.find(
          (option) => option.topic === storedValue,
        );
        if (matchingOption) {
          initialSelectedIds.push(matchingOption.id);
          finalLastId = matchingOption.id;
          currentOptions = matchingOption.sub_topics || [];
        } else {
          initialSelectedIds.push(-1);
        }
      });

      setSelectedIds(initialSelectedIds);
      setOptions(currentOptions);

      if (finalLastId !== null) {
        setLastSelectedId(finalLastId);

        const hasNoSubTopics =
          !currentOptions ||
          currentOptions.length === 0 ||
          currentOptions.every(
            (option) => !option.sub_topics || option.sub_topics.length === 0,
          );
        setCheckForValue(hasNoSubTopics);
        setHasSubTopicsAvailable(currentOptions && currentOptions.length > 0);
      }
    }
  }, [Disposition, storedDisposition]);

  useEffect(() => {
    if (options && options.length > 0) {
      const hasNoSubTopics = options.every(
        (option) => !option.sub_topics || option.sub_topics.length === 0,
      );
      setCheckForValue(hasNoSubTopics);
    } else {
      setCheckForValue(true);
    }
  }, [options]);

  const findDispositionById = (data, id) => {
    if (!data || !id) return null;

    for (const item of data) {
      if (item.id === id) {
        return item;
      }

      if (item.sub_topics && item.sub_topics.length > 0) {
        const found = findDispositionById(item.sub_topics, id);
        if (found) {
          return found;
        }
      }
    }

    return null;
  };

  const renderDropdowns = (data, level) => {
    if (!data || data.length === 0) {
      return null;
    }

    return (
      <div className="disposition_modal_cont">
        {level > 0 && <label className=" required mt-4">Sub Disposition</label>}
        <select
          name={`Level${level}`}
          className="form-select form-select-lg form-select-solid"
          onChange={handleChange}
          value={selectedIds[level] || ""}
          disabled={value !== "nonDispositionValue" && !isEditDispositionTrue}
          style={{
            background:
              value === "nonDispositionValue"
                ? ""
                : isEditDispositionTrue
                ? "#fbfbfb"
                : "rgb(233 233 233)",
          }}
        >
          <option value="" disabled>
            Select
          </option>
          {data?.map((option) => (
            <option key={option.id} value={option.id}>
              {option.topic}
            </option>
          ))}
        </select>
        {selectedIds[level] &&
          renderDropdowns(
            data.find((item) => item.id === selectedIds[level])?.sub_topics ||
              [],
            level + 1,
          )}
      </div>
    );
  };

  useEffect(() => {
    if (lastSelectedId && Disposition) {
      const dispositionItem = findDispositionById(Disposition, lastSelectedId);

      if (dispositionItem) {
        setTicketName(dispositionItem.ticket_name);

        if (
          dispositionItem.sub_topics &&
          dispositionItem.sub_topics.length > 0
        ) {
          setCheckValue(dispositionItem.sub_topics);
          setSkipDispositionQuery(true);
          setShowAdditionalField(false);
          setHasSubTopicsAvailable(true);
        } else {
          setSkipDispositionQuery(false);
          setShowAdditionalField(true);
          setHasSubTopicsAvailable(false);
        }
      }
    }
  }, [lastSelectedId, Disposition]);

  useEffect(() => {
    if (ticketDynamicFields) {
      setDynamicData(ticketDynamicFields);
    }
  }, [ticketDynamicFields]);

  useEffect(() => {
    if (ticketName) {
      let filterDataById = ticketDynamicFields?.filter(
        (name) => name?.ticket_name === ticketName,
      );

      setDynamicData(filterDataById);
    }
  }, [ticketDynamicFields, ticketName]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const selectedValue = parseInt(value);
    setSelectedId(value);

    const level = parseInt(name.replace("Level", ""));

    const newSelectedIds = [...selectedIds];
    newSelectedIds[level] = selectedValue;
    newSelectedIds.length = level + 1;
    setSelectedIds(newSelectedIds);
    setLastSelectedId(selectedValue);

    let currentOptions = Disposition;
    for (let i = 0; i <= level; i++) {
      const selectedId = i < level ? newSelectedIds[i] : selectedValue;
      if (selectedId !== undefined) {
        const found = currentOptions.find((item) => item.id === selectedId);
        if (found && i === level) {
          setOptions(found.sub_topics || []);

          setTicketName(found.ticket_name);

          if (found.sub_topics && found.sub_topics.length > 0) {
            setCheckValue(found.sub_topics);
            setSkipDispositionQuery(true);
            setShowAdditionalField(false);
            setHasSubTopicsAvailable(true);
          } else {
            setSkipDispositionQuery(false);
            setShowAdditionalField(true);
            setHasSubTopicsAvailable(false);
          }
          break;
        } else if (found) {
          currentOptions = found.sub_topics || [];
        } else {
          currentOptions = [];
          break;
        }
      }
    }
  };

  const findSelectedOption = (data, selectedId) => {
    if (!data) return null;
    for (const option of data) {
      if (option.id === selectedId) {
        return option;
      }
      const found = findSelectedOption(option.sub_topics, selectedId);
      if (found) {
        return found;
      }
    }
    return null;
  };

  const isAllLevelsSelected = () => {
    return selectedIds.every((id) => id !== undefined && id !== null);
  };

  // Validation function to check if all required dispositions are selected
  const isDispositionComplete = () => {
    if (!lastSelectedId || !Disposition) return false;

    const selectedOption = findSelectedOption(Disposition, lastSelectedId);
    if (!selectedOption) return false;

    // If the selected option has sub_topics, they must be selected
    if (selectedOption.sub_topics && selectedOption.sub_topics.length > 0) {
      return false; // Sub-topics exist but not all are selected
    }

    return true; // No sub-topics, so this is complete
  };

  const editHandler = async (e) => {
    e.preventDefault();

    // Validation 1: Check if all levels are selected
    if (!isAllLevelsSelected()) {
      toast.error("Please select a disposition for each level.");
      return;
    }

    // Validation 2: Check if disposition is complete (no pending sub-topics)
    if (!isDispositionComplete()) {
      toast.error(
        "Please select all required dispositions including sub-dispositions.",
      );
      return;
    }

    // Validation 3: Verify selected option exists and checkForValue is true
    const selectedOption = findSelectedOption(Disposition, lastSelectedId);
    if (!selectedOption || !checkForValue) {
      toast.error("Kindly fill all the disposition");
      return;
    }

    // All validations passed, proceed with the workflow
    setShouldFetch(true);
    setWorkflowModalClicked(true);
  };

  useEffect(() => {
    if (fetchDispositionStats === "rejected") {
      const errorMessage =
        dispoError?.data?.disposition?.[0] ||
        "No ticket name for the selected disposition";
      toast.error(errorMessage);

      setWorkflowModalClicked(false);
      setShouldFetch(false);
    } else if (
      fetchDispositionStats === "fulfilled" &&
      workflowModalClicked &&
      otherMailDetails?.action?.ticket
    ) {
      setStatusModalOpen(true);
    } else if (fetchDispositionStats === "fulfilled" && workflowModalClicked) {
      closeModal(true);
      toast.success("Edited successfully");
    }
  }, [
    fetchDispositionStats,
    dispoError,
    workflowModalClicked,
    otherMailDetails,
  ]);

  useEffect(() => {
    const fetchData = async () => {
      if (workflowModalClicked && fetchDispositionStats === "fulfilled") {
        const selectedOption = findSelectedOption(Disposition, lastSelectedId);

        if (!selectedOption || !checkForValue) {
          toast.error("Kindly fill all the disposition");
          return;
        }

        const requestBody = { disposition: lastSelectedId };

        try {
          const response = await trigger({
            body: requestBody,
            id: uuid,
          });
          if (response?.data) {
            await refetch();
          } else if (response?.error) {
            const errorData = (response?.error as any)?.data?.detail?.[0];
            toast.error(errorData || "Unable to edit");
          }
        } catch (error) {
          toast.error("An error occurred");
        }
      }
    };

    fetchData();
  }, [
    workflowModalClicked,
    fetchDispositionStats,
    Disposition,
    lastSelectedId,
    uuid,
    trigger,
    refetch,
    checkForValue,
  ]);

  const isLastDropdownSelected =
    selectedIds.length > 0 && selectedIds[selectedIds.length - 1] !== undefined;

  const editDispositionHandler = () => {
    setIsEditDispositionTrue(!isEditDispositionTrue);
  };

  // Enhanced save button disabled condition - matches DispositionTicketModal exactly
  const isSaveDisabled =
    !isLastDropdownSelected ||
    !selectedId ||
    !checkForValue ||
    !isDispositionComplete();

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    overflow: "hidden",
    bgcolor: "background.paper",
    border: "1px solid transparent",
    boxShadow: 2,
    borderRadius: "5px",
    p: 4,
    maxHeight: "100%",
    paddingBottom: "10px",
  };

  return (
    <div>
      <div
        className="modal-header"
        style={{
          paddingLeft: "5px",
          paddingRight: "0px",
          paddingTop: "5px",
          borderBottom: "0px",
        }}
      >
        <h2>Dispositions</h2>
        <div
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
          }}
        >
          {value !== "nonDispositionValue" && (
            <i
              className={`bi ${
                isEditDispositionTrue
                  ? "bi-pencil-fill text-primary"
                  : "bi-pencil-fill"
              }`}
              onClick={editDispositionHandler}
              data-placement="top"
              title={isEditDispositionTrue ? "Disable" : "Enable"}
              style={{
                fontSize: "16px",
                color: isEditDispositionTrue ? "#0d6efd" : "#6c757d",
              }}
            ></i>
          )}
          <CloseButton onClick={closeModal} />
        </div>
      </div>
      <div>
        <label className="required">Disposition</label>

        {renderDropdowns(Disposition, 0)}
      </div>
      <div
        style={{
          marginTop: "10px",
          display: "flex",
          justifyContent: "end",
        }}
      >
        <button
          className="btn btn-primary"
          onClick={editHandler}
          disabled={isSaveDisabled}
          style={{
            cursor: isSaveDisabled ? "not-allowed" : "pointer",
          }}
        >
          {isLoading ? (
            <>
              Saving...
              <Loader />
            </>
          ) : (
            "Save"
          )}
        </button>
      </div>

      <Modal
        open={statusModalOpen}
        onClose={closeStatusModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={{ ...style, position: "absolute" }}>
          <IconButton
            aria-label="close"
            onClick={closeModal}
            sx={{
              position: "fixed",
              top: 16,
              right: 16,
              zIndex: 1301,
              background: "white",
            }}
          >
            <GridCloseIcon />
          </IconButton>
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{ mb: 2 }}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            Workflow
          </Typography>

          <Box>
            <EmailDispositionWorkflowModal
              closeModal={closeStatusModal}
              ticketId={ticketId}
              dynamicData={dynamicData}
              fetchDispositionStatus={fetchDispositionStatus}
              refetch={refetch}
            />
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default ReplyDispositionModal;
